<!--
 * @Descripttion: 配件详情
 * @Date: 2021-06-11 11:00:37
 * @Author: lwh
 * @LastEditors: pzf
 * @LastEditTime: 2021-09-23 09:25:33
-->
<template>
    <div class="accessories-details">
        <div class="details-top">
            <!-- <div class="details-head">设备详情</div> -->
            <nav-back headTitle="配件详情" :bg="'transparent'" color="#ffffff" :showHome="true" :showIcon="true"></nav-back>
            <div class="details-con">
                <div class="img_div">
                    <img
                        v-if="pathOr('', ['image'], from).indexOf('http') != -1"
                        v-lazy="pathOr('', ['image'], from)"
                        key="image1"
                        @click="$_showCretialsImg(pathOr('', ['image'], from))"
                    />
                    <img
                        v-else-if="!pathOr('', ['image'], from) || pathOr('', ['image'], from) == ''"
                        :src="require('@/assets/images/icon_defalutimage_gray.png')"
                        key="image2"
                    />
                    <img v-else :src="from.image[0]" key="image3" @click="$_showCretialsImg(from.image[0])" />

                    <img
                        v-show="pathOr(false, ['quick_wear'], from)"
                        class="imgIcon"
                        :src="require('@/assets/images/icon_vulnerable.png')"
                    />
                </div>
                <div class="middle_content">
                    <div class="middle_content_text">
                        <!-- {{ from.name }} -->
                        <span class="wordWrap_name">{{ from.name }}</span>
                    </div>
                    <div class="middle_content_text">
                        <span>型号：</span>
                        <span class="wordWrap number_warp">{{ from.model_number }}</span>
                    </div>
                    <div class="middle_content_text">
                        <span>品号(编号)：</span>
                        <span class="wordWrap code_warp">{{ from.code }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="accessoried-conten">
            <div class="con-item">
                <span class="con-item-name">配件名称：</span>
                <span>{{ from.name || '--' }}</span>
            </div>
            <div
                class="con-item"
                v-if="isShowModelNo(from)"
            >
                <span class="con-item-name">规格型号：</span>
                <span>{{ from.model_number || '--' }}</span>
            </div> 
            <div class="con-item">
                <span class="con-item-name">{{from.is_slm ? '外部型号：' : '配件型号：'}}</span>
                <span>{{ from.external_model_number || '--' }}</span>
            </div>
            <div class="con-item">
                <span class="con-item-name">品号(编号)：</span>
                <span>{{ from.code || '--' }}</span>
            </div>
            <div class="con-item">
                <span class="con-item-name">单位：</span>
                <span>{{ from.unit || '--' }}</span>
            </div>
            <div class="con-item">
                <span class="con-item-name">易损件：</span>
                <span>{{ from.quick_wear ? '是' : '否' }}</span>
            </div>
            <div class="con-item">
                <span class="con-item-name">配件类型：</span>
                <span>{{ from.type || '--' }}</span>
            </div>
            <div class="con-item">
                <span class="con-item-name">品牌：</span>
                <span>{{ from.brand || '--' }}</span>
            </div>
            <div class="con-item">
                <span class="con-item-name">质保期：</span>
                <span>{{ from.warranty || '--' }}<span v-if="from.warranty">月</span></span>
            </div>
            <div class="con-item">
                <span class="con-item-name">使用寿命：</span>
                <span>{{ from.lifetime || '--' }}<span v-if="from.lifetime">月</span></span>
            </div>
            <div class="con-item">
                <span class="con-item-name">适用机型：</span>
                <span class="model-nos-text">{{ modelNos }}</span>
            </div>
            <div class="con-item">
                <span class="con-item-name">可替代配件：</span>
                <span class="model-nos-text">{{ replaceNames || '--' }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { pathOr } from '@/config/Utils'
import { ImagePreview } from 'vant'
import NavBack from '@/components/NavBack/index.vue'
import { get_accessory_one, get_accessory_list } from '@/service/getData'
export default {
    name: 'accessoriesDetails',
    components: {
        NavBack
    },
    data() {
        return {
            pathOr: pathOr,
            warranty_status_image: {
                0: require('@/assets/images/icon_unknown.png'),
                1: require('@/assets/images/icon_inside.png'),
                2: require('@/assets/images/icon_outside.png'),
                3: require('@/assets/images/icon_unknown.png')
            }, //1-保内；2-保外；3质保不明
            warranty_status: 0,
            accessoryId: '',
            from: {},
            modelNos: '',
            replaceNames: ''
        }
    },
    mounted() {
        // let data = JSON.parse(this.rote.$query.accessory)
        this.accessoryId = this.$route.query.id
        // 获取设备详情信息
        this.getAccessoryOne()
    },
    methods: {
        // 判断设备型号是否显示
        isShowModelNo (item) {
            return item.is_slm
                || (this.$store.state.qr_permission && this.$store.state.qr_permission['accessory_model_no'])
        },
        getAccessoryOne() {
            get_accessory_one({
                token: localStorage.getItem(location.host + 'token'),
                id: this.accessoryId
            }).then(res => {
                this.from = res
                this.modelNos = this.from.equipment_model_nos.join('、')
                if (this.from.replace_id) {
                    let id = this.from.replace_id.join(',')
                    this.getAccessoryList(id)
                }
            })
        },
        getAccessoryList(id) {
            get_accessory_list({
                token: localStorage.getItem(location.host + 'token'),
                id: id,
                page_num: 1,
                page_size: 30 // 拿30条数据
            }).then(res => {
                let resList = res.result.map(item => {
                    return {
                        value: item.id ? item.id : '',
                        label: item.name ? `${item.name}  (${item.code})` : '--'
                    }
                })
                let replaceNameList = []
                this.from.replace_id.forEach(replace => {
                    console.log(replace)
                    let code = resList.find(res => {
                        return res.value === replace
                    })
                    replaceNameList.push(code.label)
                })
                this.replaceNames = replaceNameList.join('、')
            })
        },
        $_showCretialsImg(image) {
            let images = []
            images.push(image)
            ImagePreview({
                images: images,
                showIndex: false,
                lazyLoad: false
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/mixin';
.details-head {
    font-size: vw(17);
    text-align: center;
    // height: 5vh;
    // line-height: 5vh;
}
.details-top {
    background: transparent url('../../assets/images/bg.png') no-repeat center center;
    justify-content: space-between;
    // padding: 0 vw(15) 0 vw(16);
    background-size: 100vh 100vw;
    // height: vw(164);
    .details-con {
        // margin-top: vw(10);
        display: flex;
        flex-wrap: wrap;
        justify-content: start;
        padding: 0 vw(16);
        padding-bottom: vw(25);
    }
    .img_div {
        @include wh(vw(90), vw(90));
        margin-right: vw(15);
        position: relative;
        img {
            width: vw(90);
            height: vw(90);
            flex-shrink: 0;
        }
        .imgIcon {
            width: vw(30);
            height: vw(30);
            position: absolute;
            left: 0;
            top: 0;
        }
    }
    .middle_content {
        // width: 0vw;
        word-break: break-all;
        margin-right: vw(10);
        .middle_content_text {
            color: #fff;
            margin-bottom: vw(10);
            line-height: vw(16);
            display: flex;
            flex-wrap: wrap;
            word-break: break-all;
        }
        .wordWrap_name {
            width: vw(220);
            word-wrap: break-word;
            overflow: hidden;
            word-break: break-all;
        }
        .wordWrap {
            word-wrap: break-word;
            overflow: hidden;
            word-break: break-all;
        }
        .number_warp {
            width: vw(180);
        }
        .code_warp {
            width: vw(145);
        }
    }
}
.accessoried-conten {
    padding: vw(10);
    background-color: #fff;
    height: calc(100vh - 20vh);
    .con-item {
        font-size: vw(14);
        margin-bottom: vw(15);
        .model-nos-text {
            line-height: vw(20);
        }
        .con-item-name {
            color: #999999;
        }
    }
}
</style>
